import instantsearch from 'instantsearch.js/dist/instantsearch.js';
import * as searcher from './searchWidgets'

const resultsPerPage = 4;
const results = '#filteredCommunityResults'
let search;
let filter;
let resultCount;

/**
 * Set up and start filtering on community pages
 */
if ($(results).length) {
    const basePath = window.location.pathname.replace(/\/$/, ''); // Remove trailing slash if exists
    const path1 = `Parent:"${basePath}"`;       // Non-trailing slash path
    const path2 = `Parent:"${basePath}/"`;      // Trailing slash path
    filter = `${path1} OR ${path2}`;            // Use OR operator directly without parentheses

    createSearch();
    initListeners();
}

/**
 * Create and start a filtered InstantSearch search
 */
function createSearch() {
    search = searcher.getSearch('CommunityRecent', resultsPerPage, true, filter);
    search.addWidget(
        searcher.widgetFilterHits(results, function(){checkResultCount();})
    );
    search.addWidget(
        searcher.widgetRefinementList('#facetType  .filter__sort', 'Type')
    );
    search.addWidget(
        searcher.widgetRefinementList('#facetTopic  .filter__sort', 'Topic')
    );
    search.addWidget(
        searcher.widgetRefinementList('#facetDiscipline  .filter__sort', 'Discipline')
    );
    search.addWidget(
        searcher.widgetNumericRefinementList('#facetYear .filter__sort')
    );
    search.start();
}


/**
 * Sets up listeners for various sections of the filter page to
 * give a more interactive and useful filter experience.
 */
function initListeners() {
    // display most recent index results
    $('#sort-most-recent').change(function() {
        search.helper.state.index = searcher.getIndex('CommunityRecent');
        search.helper.search();
        $('#filter__sort').text('Most Recent');
    });

    // display most popular index results
    $('#sort-most-popular').change(function() {
        search.helper.state.index = searcher.getIndex('CommunityPopular');
        search.helper.search();
        $('#filter__sort').text('Most Popular');
    });

    // see more button with max results
    $('#seeMoreBtn').click(function(e) {
        if (search.helper.state.hitsPerPage < 16) {
            search.helper.state.hitsPerPage += 4;
            search.helper.search();
        }
        checkResultCount();
        e.preventDefault();
    });
}


/**
 * Show/display the show more button when appropriate.
 */
function checkResultCount() {
    if (search.helper.lastResults) {
        resultCount = search.helper.lastResults.nbHits;
    }

    if ((!resultCount && search.helper.lastResults) ||
        search.helper.state.hitsPerPage >= resultCount) {
            $('#seeMoreBtn').css('display', 'none');
    } else {
        $('#seeMoreBtn').css('display', 'block');
    }
}



// WEBPACK FOOTER //
// ./src/js/search/filteredLandingHolderFilters.js